import { computed } from "vue";

export const svgProps = {
  size: {
    type: String,
    default: "24",
  },
  fill: {
    type: String,
    default: "black",
  },
  stroke: {
    type: String,
    default: "black",
  },
  strokeWidth: {
    type: String,
    default: "1",
  },
  title: {
    type: String,
    default: "",
  },
  ariaLabel: {
    type: String,
    default: "",
  },
};

export function useSVGAccessibility(props) {
  const titleId = `svg-title-${Math.random().toString(36).substr(2, 9)}`;

  const computedRole = computed(() =>
    props.title || props.ariaLabel ? "img" : undefined
  );

  const ariaAttributes = computed(() => {
    if (props.ariaLabel) {
      return { "aria-label": props.ariaLabel };
    } else if (props.title) {
      return { "aria-labelledby": titleId };
    }
    return { "aria-hidden": "true" };
  });

  return { titleId, computedRole, ariaAttributes };
}
